import { NovaCommanding, EntityCommand, EntityType } from '@office-start/nova-facade-types';
import { onM365AppTrigger } from './actions/onM365AppTrigger';
import { onComposeMessageExtensionTrigger } from './actions/onComposeMessageExtensionTrigger';
import { onModuleTrigger } from './actions/onModuleTrigger';
import { onAddinTrigger } from './actions/onAddinTrigger';

export const novaCommanding: NovaCommanding = {
    trigger(command: EntityCommand): Promise<void> {
        if (
            command.entity.type === EntityType.m365_app ||
            command.entity.type.toString().includes('office')
        ) {
            onM365AppTrigger(command);
        } else if (command.entity.type.toString().includes('outlook_')) {
            onModuleTrigger(command);
        } else if (
            command.entity.type === EntityType.m365_messageextension &&
            command.entity.linkedEntity
        ) {
            const [
                scenario,
                hostId,
                contextMenuHostId,
                tabId,
            ] = command.entity.linkedEntity.id.split(',');
            if (scenario.includes('Compose')) {
                onComposeMessageExtensionTrigger(
                    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                    // -> Error TS2345 (31,21): Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
                    // @ts-ignore
                    command.entity.entityId,
                    hostId,
                    contextMenuHostId,
                    tabId
                );
            }
        } else if (command.entity.type === EntityType.m365_appsideload) {
            onAddinTrigger(command);
        }
        return Promise.resolve();
    },
};
